<template>
  <!-- 系统VI设置 -->
  <div>
    <!-- 管理端登录页图标 -->
    <div class="rowsItem">
      <div class="titles">1, 管理端登录页图标:</div>
      <uploadimgs
        @input="changeFileList"
        :fileNameLists="fileNameLists"
        :limit="limit"
      ></uploadimgs>
      <div class="tips">请上传一张图片(支持上传jpg/png格式)</div>
    </div>

    <!-- 管理端首页左上角logo -->
    <div class="rowsItem">
      <div class="titles">2, 管理端首页左上角logo:</div>
      <uploadimgs
        @input="changeFileList2"
        :fileNameLists="fileNameLists2"
        :limit="limit"
      ></uploadimgs>
      <div class="tips">请上传一张图片(支持上传jpg/png格式)</div>
    </div>

    <!-- 管理端登录页背景图 -->
    <div class="rowsItem">
      <div class="titles">3, 管理端登录页背景图:</div>
      <uploadimgs
        @input="changeFileList3"
        :fileNameLists="fileNameLists3"
        :limit="limit"
      ></uploadimgs>
      <div class="tips">请上传一张图片(支持上传jpg/png格式)</div>
    </div>

    <!-- 浏览器顶部菜单显示的标题 -->
    <div class="rowsItem">
      <div class="titles">4, 浏览器顶部菜单显示的标题:</div>
      <el-input
        type="text"
        style="width: 300px"
        placeholder="请输入"
      ></el-input>
    </div>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";

export default {
  components: {
    uploadimgs,
  },
  data() {
    return {
      fileNameLists: [],
      fileNameLists2: [],
      fileNameLists3: [],
      limit: 1,
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    changeFileList2(array) {
      this.fileNameLists = array;
    },
    changeFileList3(array) {
      this.fileNameLists = array;
    },
  },
};
</script>
<style scoped lang='less'>
.rowsItem {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .titles {
    width: 260px;
    font-weight: bold;
    margin-right: 20px;
  }

  .tips {
    font-size: 13px;
    margin-bottom: 10px;
    margin-left: 20px;
  }
}
</style>